import {createAction} from "redux-act";

export interface IBannerSettings {
	isForceHub: boolean;
}

export interface ISettings {
	banner: IBannerSettings;
}

export const fetchSettingsRequest = createAction();
export const fetchSettingsSuccess = createAction<ISettings>();
